import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { SharingDialogResponse } from 'owa-sharing-dialog';
import { action } from 'satcheljs';

export const updateSharingLinkFromSharingDialog = action(
    'UPDATE_SHARING_LINK_FROM_SHARING_DIALOG',
    (linkId: string, sharingDialogResponse: SharingDialogResponse) => ({
        linkId: linkId,
        sharingDialogResponse: sharingDialogResponse,
    })
);

export const updateSharePointLinkPermission = action(
    'UPDATE_SHAREPOINT_LINK_PERMISSION',
    (linkId: string, newPermission: AttachmentPermissionLevel) => ({
        linkId: linkId,
        newPermission: newPermission,
    })
);

export const updateSharePointLinkUrl = action(
    'UPDATE_SHAREPOINT_LINK_URL',
    (linkId: string, newLinkUrl: string, oldLinkUrl: string, expirationDate: string) => ({
        linkId: linkId,
        newLinkUrl: newLinkUrl,
        oldLinkUrl: oldLinkUrl,
        expirationDate: expirationDate,
    })
);

export const setRefreshStatus = action(
    'SET_REFRESH_STATUS_FOR_LINK',
    (linkId: string, actionStatus: LinkActionStatus) => ({
        linkId: linkId,
        actionStatus: actionStatus,
    })
);

export const createSharingLink = action(
    'CREATE_SHARING_LINK',
    (
        linkId: string,
        currentUrl: string,
        canonicalUrl: string,
        newPermissionLevel: AttachmentPermissionLevel
    ) => ({
        linkId: linkId,
        currentUrl: currentUrl,
        canonicalUrl: canonicalUrl,
        newPermissionLevel: newPermissionLevel,
    })
);

export const addSharingLink = action(
    'ADD_SHARING_LINK',
    (linkId: string, linkModel: SharingLinkInfo) => ({
        linkId: linkId,
        linkModel: linkModel,
    })
);

export const tokenUnavailable = action('TOKEN_UNAVAILABLE', (linkId: string) => ({
    linkId: linkId,
}));
